import { InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Box, Button, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Redirect, useHistory } from 'react-router-dom';
import { ROUTES } from 'routing/routes';
import { useTitle } from 'shared/hooks';
import { AuthInProgress } from 'shared/providers';
import { NoPropsJustChildren } from 'shared/types';

function Div({ children }: NoPropsJustChildren) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                alignItems: 'center',
                padding: 15,
                height: 200,
            }}
        >
            {children}
        </Box>
    );
}

export function LoginPage() {
    useTitle('Paragon Price Management Login');
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const { instance, inProgress } = useMsal();

    const login = async () => {
        try {
            await instance.loginRedirect();
            history.push(ROUTES.distributorManagement);
        } catch (error: any) {
            enqueueSnackbar(error.message, { variant: 'error' });
        }
    };
    if (
        inProgress !== InteractionStatus.None &&
        inProgress !== InteractionStatus.Startup &&
        (inProgress === InteractionStatus.Login || inProgress === InteractionStatus.HandleRedirect)
    ) {
        return (
            <Div>
                <AuthInProgress />
            </Div>
        );
    }

    return (
        <>
            <AuthenticatedTemplate>
                <Redirect to={ROUTES.distributorManagement} />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <Div>
                    <Typography variant='h3'>Paragon Price Management App</Typography>
                    <Button size='large' variant='contained' color='primary' onClick={login}>
                        Login
                    </Button>
                </Div>
            </UnauthenticatedTemplate>
        </>
    );
}
